import React, { Component } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import Cover from "../../../Assets/img/default-cover-image.svg";

class CourseCard extends Component {
  render() {
    return (
      <>
        <div className="border rounded-lg overflow-hidden h-100">
          <Link
            className="w-100 th-link th-black"
            to={`/lessons/${this.props.id}`}
          >
            <div
              className="w-100"
              style={{
                height: 120,
                backgroundImage: `url(${
                  this.props.img ? this.props.img : Cover
                })`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            ></div>
            <div className="p-2">
              <div className="th-12 th-grey text-capitalize">
                {this.props.sub}
              </div>
              <div className="th-12 th-medium text-capitalize">
                {this.props.title}
              </div>
              <div className="th-10 th-grey text-capitalize">
                {this.props.first_name} {this.props.last_name}
              </div>
            </div>
          </Link>
        </div>
      </>
    );
  }
}
export default CourseCard;
